import { WalletPaymentMethodType } from './wallet-payment-method-type';

export interface WalletPaymentMethodIdentifier {
  type: WalletPaymentMethodType;
}
